import {Product} from 'mw/api/Metadata';
import {EntitledProduct} from 'mw/common/entitled-products/EntitledProductInterface';
import {EntitledProductObject} from 'mw/common/entitled-products/EntitledProductObject';

export class EntitledProductMapper {
  public static fromProducts(products: Product[]): EntitledProduct[] {
    return products.map(product => new EntitledProductObject(product));
  }
}
